import * as React from 'react'
import { Card } from 'reactstrap';
import { ContentCardHeader } from '../../../components/ui/ContentCardHeader';
import { DataGrid, DataGridSortOrder } from '../../../components/ui/DataGrid';
import { FontAwesomeIcon } from '../../../components/ui/FontAwesomeIcon';
import { getAuditLogs, IAuditLogIndex } from '../../../containers/CommentDetails/lib/http';

interface ICommentCodesAuditLogGridState {
  auditLogs: IAuditLogIndex[]
  sortBy: keyof IAuditLogIndex
  sortOrder: DataGridSortOrder
  loading: boolean
}

export class CommentCodesAuditLogGrid extends React.Component<{}, ICommentCodesAuditLogGridState> {
  state: ICommentCodesAuditLogGridState = {
    auditLogs: [],
    sortBy: 'actionDate',
    sortOrder: 'asc',
    loading: false,
  }

  componentWillMount() {
    this.setState({ loading: true })

    getAuditLogs('comment code').then((auditLogs) => {
      this.setState({ auditLogs, loading: false })
    })
  }

  render() {
    return (
      <Card>
        <ContentCardHeader
          sticky
          borderBottom
          header={
            <section className="d-md-flex justify-content-between">
              <header>
                <h2 className="d-inline-block mr-2">
                  <span>Comment Codes Audit Logs</span>
                  {this.state.loading &&
                    <FontAwesomeIcon icon="cog" size="sm" verticalAlign="middle" spin muted />
                  }
                </h2>
              </header>
              <article>
                {/* <Button color="white">
                  <FontAwesomeIcon icon="plus" fixedWidth size="sm" />
                  <span>&nbsp;Add Comment Code</span>
                </Button> */}
              </article>
            </section>
          }
        />

        <DataGrid<IAuditLogIndex>
          records={this.state.auditLogs}
          sortBy={this.state.sortBy}
          sortOrder={this.state.sortOrder}
          onSortChange={(sortBy, sortOrder) => this.setState({ sortBy, sortOrder })}
          columns={[
            {
              property: 'actionDate', header: 'Date', render: (record) =>
                <section style={{ whiteSpace: 'nowrap' }}>{record.actionDate}</section>
            },
            //{ property: 'key', header: 'Key' },
            //{ property: 'project', header: 'Project' },
            { property: 'username', header: 'User' },
            { property: 'ipAddress', header: 'IP Address' },
            { property: 'action', header: 'Action' },
            { property: 'description', header: 'Description' },
          ]}
        />
      </Card>
    )
  }
}
